export default function FileThumb({ filename }) {
  const ext = filename.split(".").pop().toLowerCase();
  const colors = { pdf: { bg: "#FCEBEB", emoji: "📄" }, pptx: { bg: "#FAEEDA", emoji: "📊" }, docx: { bg: "#E6F1FB", emoji: "📝" } };
  const c = colors[ext] || { bg: "#f3f4f6", emoji: "📄" };
  return <div style={{ width: "32px", height: "32px", borderRadius: "8px", background: c.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", flexShrink: 0 }}>{c.emoji}</div>;
}